/* eslint-disable @typescript-eslint/no-unused-vars, check-file/filename-blocklist -- pre-existing in this legacy file; the dark-mode sweep only themes its colour literals */
import React from 'react';
import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
  useToast,
  Link,
} from '@chakra-ui/react';
import { InfoCircle, XClose } from '@kula-ai/icons-core';

const variants = {
  primary: {
    color: 'white',
    iconColor: '255, 255, 255',
    bgColor: 'ats-negative',
  },
  secondary: {
    color: 'var(--kula-dark-secondary-900, #454647)',
    iconColor: '242, 153, 74',
    bgColor: 'rgb(255 242 204 / var(--kula-dark-pastel-alpha, 1))',
  },
  normal: {
    color: 'var(--kula-dark-secondary-900, #454647)',
    iconColor: '0,0,0',
    bgColor: 'white',
  },
};

export const NudgeToast = ({ config = {}, onClose = () => {} }) => {
  const toast = useToast();
  const { id, title, subTitle, variant = 'normal', cta = {} } = config;
  const { color, iconColor, bgColor } = variants[variant];
  const {
    label,
    icon: ctaIcon,
    onClick,
    color: ctaColor,
    bgColor: ctaBgColor,
    Wrapper,
    wrapperProps,
    linkProps = {},
  } = cta;

  const renderCircleIcon = () => {
    return (
      <Box display="inline-block" p="12px">
        <Box
          width="46px"
          height="46px"
          borderRadius="full"
          border="2px solid "
          borderColor={`rgba(${iconColor}, 0.15)`}
          display="flex"
          padding="4px"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            width="100%"
            height="100%"
            borderRadius="full"
            border="2px solid"
            display="flex"
            borderColor={`rgba(${iconColor}, 0.3)`}
            alignItems="center"
            justifyContent="center"
          >
            <Icon
              w="20px"
              h="20px"
              as={InfoCircle}
              color={`rgba(${iconColor})`}
            />
          </Box>
        </Box>
      </Box>
    );
  };

  const renderCta = () => {
    return (
      <Flex
        gap="8px"
        p="9px 12px"
        onClick={onClick}
        border={variant === 'normal' && '1px solid #EFECF0'}
        w="max-content"
        cursor="pointer"
        borderRadius="md"
        as={Wrapper && Button}
        type={Wrapper && 'submit'}
        background={Wrapper && 'transparent'}
        _hover={{
          background: Wrapper && 'transparent',
        }}
        mt="12px"
        bg={ctaBgColor}
      >
        {ctaIcon && <Icon as={ctaIcon} color={ctaColor} />}
        {linkProps?.href ? (
          <Link
            fontSize="12px"
            fontWeight="semiBold"
            color={ctaColor}
            {...linkProps}
          >
            {label}
          </Link>
        ) : (
          <Text
            size="sm-semi-bold"
            color={ctaColor}
            _hover={{ textDecoration: 'underline' }}
          >
            {label}
          </Text>
        )}
      </Flex>
    );
  };

  const customToastDesign = (closeToaster) => (
    <Flex minW={'606px'} maxW={'606px'} bgColor={bgColor} borderRadius="6px">
      {renderCircleIcon()}
      <Flex flexDir="column" w="100%" gap="4px" p="14px 0">
        <Text color={color} size="md-semi-bold">
          {title}
        </Text>
        <Text maxW="90%" color={color} size="sm-medium">
          {subTitle}
        </Text>
        {label && Wrapper ? (
          <Wrapper {...wrapperProps}>{renderCta()}</Wrapper>
        ) : (
          label && renderCta()
        )}
      </Flex>
      <Icon
        mt="12px"
        mr="12px"
        cursor="pointer"
        color={color}
        w="20px"
        h="20px"
        onClick={() => {
          closeToaster();
          onClose();
        }}
        as={XClose}
      />
    </Flex>
  );

  if (!toast.isActive(id))
    toast({
      id,
      position: 'top',
      duration: null,
      containerStyle: {
        maxWidth: 'unset',
      },
      render: ({ onClose: closeToaster }) => customToastDesign(closeToaster),
    });

  return null;
};
